<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}" class="pageHeader">智能门禁管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">

        <el-form-item label="院系">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="formInline.structure_1" placeholder="请选择院系" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门禁状态">
          <el-select v-model="formInline.door_status" clearable filterable placeholder="请选择门禁状态">
            <el-option v-for="item in $store.state.isOpens" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">添加门禁</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="training_name" label="实训室" min-width="200">
      </custom-table-column>
      <custom-table-column prop="door_status" label="门禁状态" width="150" :formatter="format_status_open_close">
      </custom-table-column>
      <custom-table-column prop="building_name" label="所属楼宇" width="180">
      </custom-table-column>
      <custom-table-column prop="structure_1" label="所属院系" width="180">
      </custom-table-column>
      <custom-table-column prop="major" label="所属专业" width="180">
      </custom-table-column>
      <custom-table-column prop="person" label="实训室负责人" width="120">
      </custom-table-column>
      <custom-table-column fixed="right" label="门禁设置" width="260">
        <template slot-scope="scope">
          <div class="row_flex">
            <div>
              <p>人脸识别</p>
              <el-switch v-model="scope.row.rlsb" @change="handleSwitchChange(...arguments,'rlsb',scope.row.id)" :active-value="1" :inactive-value="0">
              </el-switch>
            </div>
            <div>
              <p>IC卡</p>
              <el-switch v-model="scope.row.icc" @change="handleSwitchChange(...arguments,'icc',scope.row.id)" :active-value="1" :inactive-value="0">
              </el-switch>
            </div>
            <div>
              <p>指纹识别</p>
              <el-switch v-model="scope.row.zwsb" @change="handleSwitchChange(...arguments,'zwsb',scope.row.id)" :active-value="1" :inactive-value="0">
              </el-switch>
            </div>
            <div>
              <p>密码开锁</p>
              <el-switch v-model="scope.row.mmks" @change="handleSwitchChange(...arguments,'mmks',scope.row.id)" :active-value="1" :inactive-value="0">
              </el-switch>
            </div>
          </div>

        </template>
      </custom-table-column>
      <custom-table-column fixed="right" label="开关" width="80">
        <template slot-scope="scope">
          <el-button v-if="scope.row.door_status==0" @click="handleOper(scope.row.id,1)" type="text" size="small">开门</el-button>
          <el-button v-if="scope.row.door_status==1" @click="handleOper(scope.row.id,0)" type="text" size="small">关门</el-button>
        </template>
      </custom-table-column>
      <!-- <custom-table-column prop="desc" label="备注" min-width="200">
      </custom-table-column> -->
      <custom-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <!-- <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">解除绑定</el-button>
          <el-button @click="handleOpenRecord(scope.row.id)" type="text" size="small">开关记录</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" style="width:206px;" :placeholder="`请选择${$store.state.themeTitle}室`" >
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门禁状态" prop="door_status">
          <el-select v-model="ruleForm.door_status" clearable filterable placeholder="请选择门禁状态" style="width:206px;">
            <el-option v-for="item in $store.state.isOpens" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人脸识别" prop="rlsb">
          <el-select v-model="ruleForm.rlsb" clearable filterable placeholder="请选择人脸识别设置" style="width:206px;">
            <el-option v-for="item in $store.state.isSbOpens" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="IC卡" prop="icc">
          <el-select v-model="ruleForm.icc" clearable filterable placeholder="请选择IC卡设置" style="width:206px;">
            <el-option v-for="item in $store.state.isSbOpens" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指纹识别" prop="zwsb">
          <el-select v-model="ruleForm.zwsb" clearable filterable placeholder="请选择指纹识别设置" style="width:206px;">
            <el-option v-for="item in $store.state.isSbOpens" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码开锁" prop="mmks">
          <el-select v-model="ruleForm.mmks" clearable filterable placeholder="请选择密码开锁设置" style="width:206px;">
            <el-option v-for="item in $store.state.isSbOpens" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="detailDialogVisible" width="746px">
      <!-- <div>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleAddItem">添加消息</el-button>
          </el-form-item>
        </el-form>
      </div> -->
      <custom-table :data="tableData1" ref="table" border style="width: 100%">
        <custom-table-column prop="door_status" label="门禁状态">
        </custom-table-column>
        <custom-table-column prop="user_name" label="操作人">
        </custom-table-column>
        <custom-table-column prop="created_at" label="操作时间">
        </custom-table-column>
        <!-- <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleDeletItem(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinFormatter],
  data() {
    return {
      props: {
        label: 'name',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        door_status: '',
        training_room: '',
        structure_1: '',
      },
      formInline1: {},
      levell: [1],
      selectName: '',
      organLabel: '',
      ruleForm: {
        training_room_id:'',
        door_status:'',
        rlsb:0,
        icc:0,
        zwsb:0,
        mmks:0
      },
      rules: {
        training_room_id: [{ required: true, message: '请选择所属实训室', trigger: 'change' }],
        door_status: [{ required: true, message: '请选择门禁状态', trigger: 'change' }],
        rlsb: [{ required: true, message: '请设置人脸识别', trigger: 'change' }],
        icc: [{ required: true, message: '请设置IC卡', trigger: 'change' }],
        zwsb: [{ required: true, message: '请设置指纹识别', trigger: 'change' }],
        mmks: [{ required: true, message: '请设置密码开锁', trigger: 'change' }],
      },
      fileFieldName: 'annexes',
      innerDialogVisible: false,
      detailDialogVisible: false,
      ruleForm1: {
        id: '',
        content: '',
      },
      itemTitle: '',
      typee: 'add',
      rules1: {
        content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }],
      },
      tableData1: [],
      total1: 0,
      sbLabel: {
        rlsb: '人脸识别',
        icc: 'IC卡',
        zwsb: '指纹识别',
        mmks: '密码开锁',
      },
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getStandards');
    this.$store.dispatch('getTarinMent');
  },
  watch: {},
  methods: {
    handleOpenRecord(id) {
      this.ruleForm1.id = id;
      this.detailDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.pageChild1.page == 1;
        this.getList1(id);
      });
    },
    handleOper(id, state) {
      this.confirmBox('warning', `此操作将${state == 1 ? '开启' : '关闭'}该门禁，是否继续`, { id, state }, this.openOrclose);
    },
    handleSwitchChange(val, type, id) {
      this.confirmBox('warning', `此操作将${val == 1 ? '启用' : '关闭'}该门禁的${this.sbLabel[type]}功能，是否继续`, { val, type, id }, this.setDoorOption);
    },
    handleDelet(id) {
      this.confirmBox('warning', `此操作将解绑该门禁，是否继续`, { id }, this.deleteMethod);
    },
    async setDoorOption(params) {
      let data = {};
      data[params.type] = params.val;
      let res = await this.$api.instance.interfaceServer(`api/wlw/intel_access_control/setting/${params.id}`, 'post', data);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        // this.getList();
      }
    },
    async openOrclose(params) {
      let res = await this.$api.instance.interfaceServer(`api/wlw/intel_access_control/setdoor/${params.id}`, 'post', { door_status: params.state });
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '操作成功！',
        });
        this.getList();
      }
    },
    async addCheckItem() {
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/msg/add`, 'post', this.ruleForm1);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '添加消息成功！',
        });
        this.clearState1();
      }
    },
    clearState1() {
      this.resetForm('ruleForm1');
      this.ruleForm1.content = '';
      this.innerDialogVisible = false;
      this.getList1(this.ruleForm1.id);
    },
    async getList1(id) {
      let params = {
        page: this.$refs.pageChild1.page,
        size: this.$refs.pageChild1.size,
      };
      let res = await this.$api.instance.interfaceServer(`api/wlw/intel_access_control/doorlog/${id}`, 'post', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    handleAddItem() {
      this.innerDialogVisible = true;
      this.typee = 'add';
      this.itemTitle = '新增开关记录';
      this.ruleForm1.content = '';
    },
    resetItemForm(formName) {
      this.$refs[formName].resetFields();
    },
    // handleEdit(row, filterArr = ['school_id', 'updated_at', 'created_at']) {
    //   this.type = 'edit';
    //   this.title = '编辑';
    //   this.ruleForm = this.$until.delProp(row, filterArr);
    //   this.centerDialogVisible = true;
    // },

    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod(params) {
      let res = await this.$api.instance.interfaceServer(`api/wlw/intel_access_control/delete/${params.id}`, 'post', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '解绑成功！',
        });
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/wlw/intel_access_control/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // handleAdd() {
    //   this.type = 'add';
    //   this.title = '新增';
    //   if (this.selectName) {
    //     this.selectName = '';
    //   }
    //   this.centerDialogVisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.uploadd.setRefFileList('');
    //   });
    //   this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
    //   this.$nextTick(() => {
    //     if (this.$refs.ruleForm) {
    //       this.$refs.ruleForm.clearValidate();
    //     }
    //   });
    // },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/edit`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleQuery() {
      // this.beforeQuery();
      if (this.selectNodeForQuery.level == 1) {
        this.formInline.structure_1 = this.selectNodeForQuery.structure_names;
      } else {
        this.formInline.structure_1 = '';
      }
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/wlw/intel_access_control/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
.row_flex {
  display: flex;
  justify-content: space-around;
  p {
    text-align: center;
  }
}
</style>
